import axios from "axios";
import Vue from "vue";
import router from "@/router";
// 创建 axios 实例
// axios.defaults.withCredentials = true; // 允许携带cookie
// axios.defaults.timeout = 20000;
let loginUrl = "https://cqc-server-auth-wechat.jsti-smart.cn";
if (process.env.NODE_ENV == "production") {
  loginUrl = "https://cqc-server-auth-wechat.jsti-smart.cn";
}
const requestToken = axios.create({
  // API 请求的默认前缀
  baseURL: loginUrl,
  timeout: 600000, // 请求超时时间
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8"
    // 'Access-Control-Allow-Methods':'POST,GET,DELETE'
  }
});

// requestToken拦截器
requestToken.interceptors.request.use(
  config => {
    if (process.env.NODE_ENV == "development") {
      config.headers["from"] = "app";
    } else {
      config.headers["from"] = "web";
    }
    const token = window.sessionStorage.getItem("tokenProcedure");
    // 让每个请求携带自定义 token
    // 如果 token 存在
    if (token) {
      // config.headers['Access-Token'] = token
      // config.headers['token'] = token
      // config.headers['from'] = 'web'
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response拦截器
requestToken.interceptors.response.use(
  response => {
    if (response.data && response.data.code === 401) {
      // 401, token失效
      Vue.cookie.delete("token");
      router.push({ name: "HomePage" });
    }
    return response;
  },
  error => {
    // router.push('redirect:http://ti.sso-cas.jsti-smart.cn/cas/login?service=http://ti.cqc-server-auth.jsti-smart.cn/callback')

    return Promise.reject(error);
  }
);
export default requestToken;



// WEBPACK FOOTER //
// ./src/utils/requestToken.js